<div [ngClass]="{'darkMode': darkModeService.darkMode}" class="logs" #scroll>
  <ul>
    <li class="item" *ngFor="let m of logMessage$"> {{ m.message }}</li>
  </ul>
</div>

